export const namespace = 'user';
